import React from 'react';
import { Checkbox } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import PermissionCategoryViewModel, {
  PermissionCategory,
} from '../models/PermissionCategoryViewModel';
import { usePermissionCategoryContext } from '../PermissionCategoryContext';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
`;

const StyledCategoryCheckbox = styled.div`
  display: flex;
  align-items: center;
  height: 36px;

  > .space-el {
    width: 16px;
  }
`;

const SpaceElement = () => <div className="space-el" />;

const StyledPermissionCheckboxGroup = styled.div``;

const StyledPermissionCheckbox = styled.div<{ bg?: string }>`
  display: flex;
  height: 36px;
  align-items: center;
  margin-bottom: 1px;
  background-color: ${({ bg }) => bg};

  > .space-el {
    width: 42px;
  }
`;

type CCGProps = {
  category: PermissionCategory;
};

const CategoryCheckBoxGroup = ({ category }: CCGProps) => {
  const { onGroupChecked, onPermissionChecked } =
    usePermissionCategoryContext();

  const isPartialCheckbox =
    PermissionCategoryViewModel.areOnlySomeOfPermissionChecked(
      category.permissions,
    );
  const groupCheckboxVariant = isPartialCheckbox
    ? 'default-partial'
    : 'default';

  return (
    <StyledContainer>
      <StyledCategoryCheckbox>
        <SpaceElement />
        <Checkbox
          id={category.name}
          value={category.name}
          data-testid={`${groupCheckboxVariant}-${category.name}`}
          variant={groupCheckboxVariant}
          checked={category.isChecked || isPartialCheckbox}
          aria-label={category.name}
          onChange={() => {
            onGroupChecked(category.name);
          }}
        >
          {category.name}
        </Checkbox>
      </StyledCategoryCheckbox>
      <StyledPermissionCheckboxGroup>
        {category.permissions.map((p, i) => (
          <StyledPermissionCheckbox
            key={i}
            bg={p.isChecked ? '#B2E9F931' : 'transparent'}
          >
            <SpaceElement />
            <Checkbox
              id={p.permission}
              value={p.permission}
              variant="default"
              checked={p.isChecked}
              aria-label={p.permission}
              onChange={() => {
                onPermissionChecked({
                  group: category.name,
                  permission: p.permission,
                });
              }}
            >
              {p.permission}
            </Checkbox>
          </StyledPermissionCheckbox>
        ))}
      </StyledPermissionCheckboxGroup>
    </StyledContainer>
  );
};

export default CategoryCheckBoxGroup;
